import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useIsRecording from '../../../hooks/useIsRecording/useIsRecording';
import { useAppState } from '../../../state';
import StartRecordingIcon from '../../../icons/StartRecordingIcon';
import StopRecordingIcon from '../../../icons/StopRecordingIcon';

export default function RecordButton(props: { disabled?: boolean; className?: string }) {
  const { isFetching, updateRecordingRules } = useAppState();
  const isRecording = useIsRecording();
  const { room } = useVideoContext();

  const theme = useTheme();
  const redColor = theme.palette.error.light;

  return (
    <IconButton
      style={{ width: '48px', height: '48px', border: `solid 1px ${redColor}` }}
      className={props.className}
      disabled={isFetching}
      onClick={() => {
        if (isRecording) {
          updateRecordingRules(room!.name, [{ type: 'exclude', all: true }]);
        } else {
          updateRecordingRules(room!.name, [{ type: 'include', all: true }]);
        }
      }}
      data-cy-audio-toggle
    >
      {isRecording ? <StopRecordingIcon color={'red'} /> : <StartRecordingIcon color={'red'} />}
    </IconButton>
  );
}
